import { render, staticRenderFns } from "./CheckoutFooter.vue?vue&type=template&id=b25a6864&scoped=true"
import script from "./CheckoutFooter.vue?vue&type=script&lang=js"
export * from "./CheckoutFooter.vue?vue&type=script&lang=js"
import style0 from "./CheckoutFooter.vue?vue&type=style&index=0&id=b25a6864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25a6864",
  null
  
)

export default component.exports